import { Select } from "@light-technology/components";
import { MarkerPin04 } from "@untitledui/icons";
import type { Key } from "react";
import { SERVICE_TERRITORY_ITEMS, type ServiceTerritory } from "./common";

type ServiceTerritorySelectProps = {
  value: ServiceTerritory;
  onChange: (value: ServiceTerritory) => void;
};

export const ServiceTerritorySelect = ({
  value,
  onChange,
}: ServiceTerritorySelectProps) => {
  return (
    <Select
      label="Service territory"
      items={SERVICE_TERRITORY_ITEMS}
      value={value}
      onChange={(value: Key | null) => {
        const item = SERVICE_TERRITORY_ITEMS.find((item) => item.id === value);
        if (item) {
          onChange(item.id as ServiceTerritory);
        }
      }}
      placeholderIcon={MarkerPin04}
      isRequired
      className="min-w-40"
      aria-label="Select service territory"
    >
      {(item) => <Select.Item id={item.id}>{item.label}</Select.Item>}
    </Select>
  );
};
